import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PARTNERS } from "@/data/site";

export const PARTNERS_QUERY = ["partners"];

export const PARTNER_SIZES = { xs: "h-5 sm:h-7", sm: "h-6 sm:h-8", md: "h-9 sm:h-11", lg: "h-12 sm:h-14" };
export const partnerHeight = (size) => PARTNER_SIZES[size] || PARTNER_SIZES.md;

const FALLBACK = PARTNERS.map((p) => ({ ...p, size: "md" }));

/** Partners managed in Admin > Partners; built-in list is used only if the API is unreachable. */
export function usePartners() {
  const { data, isError } = useQuery({
    queryKey: PARTNERS_QUERY,
    queryFn: () => api.get("/partners").then((r) => (Array.isArray(r.data) ? r.data : [])),
    staleTime: 60_000,
  });
  if (isError) return FALLBACK;
  return data ?? [];
}
